import { render, staticRenderFns } from "./BitoChatIcon.vue?vue&type=template&id=733367cd&scoped=true&"
import script from "./BitoChatIcon.vue?vue&type=script&lang=js&"
export * from "./BitoChatIcon.vue?vue&type=script&lang=js&"
import style0 from "./BitoChatIcon.vue?vue&type=style&index=0&id=733367cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733367cd",
  null
  
)

export default component.exports